import { render } from "./site-header-desktop.vue?vue&type=template&id=33a8e487"
import script from "./site-header-desktop.vue?vue&type=script&lang=js"
export * from "./site-header-desktop.vue?vue&type=script&lang=js"

import "./site-header-desktop.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__